/* eslint-disable quotes */
import { ApiError } from 'models'
import { PaymentType } from 'models/productsV3.model'

export const PRODUCTS_LIST_FETCH_ERROR: ApiError = {
  type: 'Product List Retrieval Error',
  // eslint-disable-next-line quotes
  message: "Sorry, we couldn't fetch the list of available products. Please try again later.",
}

export const SELECTED_PRODUCTS_LIST_FETCH_ERROR: ApiError = {
  type: 'Product Retrieval Error',
  message: "Sorry, we couldn't fetch the selected products. Please try again later.",
}

export const PLAN_LIST_FETCH_ERROR: ApiError = {
  type: 'Plan List Retrieval Error',
  message: "Sorry, we couldn't fetch the list of plans. Please try again later.",
}

export const NO_PRODUCTS_SELECTED_ERROR: ApiError = {
  type: 'No Products Selected',
  message: 'To proceed further, please select at least one product from the list.',
}

export const CRM_REF_ID_ERROR = {
  title: 'Error: CRM Ref ID Not Found',
  message: "We couldn't locate the CRM reference ID.",
}

export const SF_TOKEN_ERROR = {
  title: 'Expired Salesforce Token',
  message: 'Your Salesforce token has expired. Please log out and then log back in to proceed.',
}

export const PAYMENT_TYPE_UPDATE_ERROR = {
  type: 'Payment Type Update Error',
  message:
    "Sorry, we couldn't update the payment type for this opportunity. Please try again later.",
}

export const NO_SEARCH_RESULTS_MESSAGE =
  "Sorry, we couldn't find what you're looking for. Can you try a different word?"

export const NO_PLANS_FOUND_MESSAGE =
  'No plans found for this product. Please select a different product.'

export const PaymentTypeOptions = [
  { key: PaymentType.FULLPAYMENT, value: 'Full Payment' },
  { key: PaymentType.PARTPAYMENT, value: 'Partial Payment' },
  { key: PaymentType.POSTDEPLOYMENTPAYMENT, value: 'Payment Post Deployment' },
  { key: PaymentType.POSTINVOICING, value: 'Post Invoicing' },
]

export const AllPaymentTypeOptions = [
  { key: PaymentType.FULLPAYMENT, value: 'Full Payment' },
  { key: PaymentType.PARTPAYMENT, value: 'Partial Payment' },
  { key: PaymentType.POSTDEPLOYMENTPAYMENT, value: 'Payment Post Deployment' },
  { key: PaymentType.POSTINVOICING, value: 'Post Invoicing' },
  { key: PaymentType.SPONSOREDPAYMENT, value: 'Sponsored Payment' },
]
